import React, { useCallback } from 'react'

import Translator from 'bazinga-translator'

import useGameDialog from '../../../../../containers/GameDialogBox/hooks/useGameDialog'
import { MobileButtonsWrapper } from './styles/MobileButtonsWrapper'
import PlayButton from './styles/PlayButton'

interface Props {
  slug: string
}

function MobileButtons({ slug }: Props) {
  const { changeGameDialog } = useGameDialog()
  const openDialog = useCallback(() => changeGameDialog(slug), [slug])

  return (
    <MobileButtonsWrapper>
      <PlayButton
        activeClassName="MobileBtn-PlayBtn"
        onClick={openDialog}
      >
        {Translator.trans('play_btn')}
      </PlayButton>
    </MobileButtonsWrapper>
  )
}

export default MobileButtons
